import { WidgetInstance } from 'friendly-challenge';
import { useCallback, useEffect, useRef } from 'react';

interface FriendlyCaptchaProps {
  siteKey: string;
  locale?: string;
  theme?: 'light' | 'dark';
  onVerify: (token: string) => void;
}

export const FriendlyCaptcha = ({
  siteKey,
  locale = 'en',
  theme = 'light',
  onVerify,
}: FriendlyCaptchaProps): JSX.Element => {
  const container = useRef<HTMLDivElement>(null);
  const widget = useRef<WidgetInstance>();

  const doneCallback = useCallback(
    (token: string): void => {
      onVerify(token);
    },
    [onVerify]
  );

  const errorCallback = useCallback((err: string): void => {
    console.error(err);
  }, []);

  useEffect(() => {
    if (!widget.current && container.current) {
      widget.current = new WidgetInstance(container.current, {
        startMode: 'none',
        doneCallback,
        errorCallback,
      });
    }

    return () => {
      if (widget.current !== undefined) widget.current.reset();
    };
  }, [container, doneCallback, errorCallback]);

  return (
    <div
      ref={container}
      className={`frc-captcha ${theme === 'dark' ? 'dark' : ''}`}
      data-sitekey={siteKey}
      data-lang={locale}
    />
  );
};
